/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type OrgSettingsPutOtherBotPolicy = typeof OrgSettingsPutOtherBotPolicy[keyof typeof OrgSettingsPutOtherBotPolicy] | null;


export const OrgSettingsPutOtherBotPolicy = {
  auto_leave: 'auto_leave',
  stay: 'stay',
} as const;
